import Base from "./base";

const Fallback = () => (
	<Base>
		{""}
	</Base>
);

export default Fallback;
